import React, { CSSProperties } from "react";
import styles from "./LabelAndValue.module.scss";

type LabelColor = "primary" | "secondary";

type TLabelAndValue = {
	label: string;
	value: string | number;
	labelStyle?: CSSProperties;
	valueStyle?: CSSProperties;
	labelColor?: LabelColor;
} & React.ComponentProps<"div">;

const LabelAndValue: React.FC<TLabelAndValue> = ({ label, value, labelStyle, valueStyle, labelColor = "primary", ...rest }) => {
	return (
		<div className={styles.labelAndValueRoot} {...rest}>
			<div data-label-color={labelColor} className={styles.label} style={labelStyle}>
				{label}
			</div>
			<div className={styles.value} style={valueStyle}>
				{value}
			</div>
		</div>
	);
};

export default LabelAndValue;
